'use strict';

var React = require('react');
var index = require('../Flex/index.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const HeaderNavBarDesktop = React.forwardRef(({ items, logo, search, settings, ...props }, ref) => (React__default.default.createElement(styles.Styled.Container, { ...props, ref: ref },
    React__default.default.createElement(index.Flex.Row, { space: "m", justifyContent: "space-between" },
        React__default.default.createElement(index.Flex.Row, { space: "m" },
            React__default.default.createElement(styles.Styled.LogoContainer, null, logo),
            React__default.default.createElement(styles.Styled.TabContainer, null, items)),
        React__default.default.createElement(index.Flex.Row, { space: "l" },
            search && React__default.default.createElement("div", null, search),
            settings && React__default.default.createElement("div", null, settings))))));

exports.HeaderNavBarDesktop = HeaderNavBarDesktop;
//# sourceMappingURL=Desktop.js.map
